import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SubSection from '../../../common/components/SubSection';
import ConfirmationInfo from '../components/ConfirmationInfo';
import ArticleList from '../../../common/components/ArticleList';
import ConfirmationBlurb from '../components/ConfirmationBlurb';
import { licensingContactEmail } from '../constants';
import ArticleLicensingService from '../services/ArticleLicensingService';

const ConfirmationScreen = () => {
  const { token: checkoutToken } = useParams();
  const [articleTitle, setArticleTitle] = useState();
  const [articleUrl, setArticleUrl] = useState();
  const [submitterEmail, setSubmitterEmail] = useState();

  // Get LicensedNewspostPurchase data from backend
  useEffect(() => {
    const articleLicensingApi = new ArticleLicensingService();
    (async () => {
      try {
        const { data } = await articleLicensingApi.getArticleLicense(checkoutToken);
        setArticleTitle(data.newspost.title);
        setArticleUrl(data.newspost.url);
        setSubmitterEmail(data.submitterEmail);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const contentItems = [
    {
      key: 'licensing-for-marketers',
      imgSrc: 'https://assets.studioid.com/images/Zz04ZDM1MmIzMmFlZTIxMWVkYTFjYTlhZTA3ODg5NzhlNA==?width=1000&height=670',
      articleTitle: 'Content Licensing for Marketers: Everything You Need to Know',
      articleUrl: 'https://www.studioid.com/springboard/pov/content-licensing-for-marketers-everything-you-need-to-know/',
    },
    {
      key: 'smart-ways',
      imgSrc: 'https://assets.studioid.com/images/Zz0yM2NlYzdiNDI3YzYxMWVkYWQ5YTI2YzAwNzk2NmU4ZQ==?width=1000&height=670',
      articleTitle: '5 Smart Ways to Scale Your Website’s Content',
      articleUrl: 'https://www.studioid.com/springboard/how-to/5-smart-ways-to-scale-your-websites-content/',
    },
    {
      key: 'guide',
      imgSrc: 'https://assets.studioid.com/images/Zz00NjkwYmJmNDFjZWMxMWViOWY5NDBhNjZiODQ4YjE5Zg==?width=1000&height=670',
      articleTitle: 'Licensed Content 2023: The Definitive Guide',
      articleUrl: 'https://www.studioid.com/springboard/pov/licensed-content-2022-the-definitive-guide/',
    },
  ];

  return (
    <>
      <div className="column row">
        <ConfirmationInfo checkoutToken={checkoutToken}>
          <ConfirmationBlurb
            articleUrl={articleUrl}
            articleTitle={articleTitle}
            submitterEmail={submitterEmail}
            licensingContactEmail={licensingContactEmail}
          />
        </ConfirmationInfo>
        <SubSection
          title="EXPLORE"
          linkedTitle="CONTENT LICENSING"
          link="https://www.industrydive.com/divemarketplace"
          extraHeaderClass="header--sidebar-ified"
        >
          <ArticleList contentItems={contentItems} />
        </SubSection>
      </div>
    </>
  );
};

export default ConfirmationScreen;
